const cssToObjectMixin = {
  methods: {
    toCamelCase(str) {
      return str.replace(/-([a-z])/g, (match, letter) => letter.toUpperCase())
    },

    // Function to parse CSS string and convert to object
    parseCSSToObject(cssString) {
      if (!cssString) return

      const cssObject = {}
      const properties = cssString?.trim()?.split(';')

      for (const property of properties) {
        if (property.trim() !== '') {
          const [key, value] = property.split(':').map((item) => item.trim())
          cssObject[this.toCamelCase(key)] = value
        }
      }

      return cssObject
    },
  },
}

export default cssToObjectMixin
